import React, { useState } from 'react';
import styles from './UpdatesTabContent.module.css';
import { createUnitUpdate, fetchUnitUpdateDetails } from '../services/unitService';

export default function AddUnitUpdateForm({ unitId, onCancel, onSuccess }) {
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const validate = () => {
    const errs = {};
    if (!description.trim()) errs.description = 'Description is required.';
    if (!images || images.length === 0) errs.images = 'At least one image is required.';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleImageUpload = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.multiple = true;
    fileInput.onchange = (e) => {
      const files = Array.from(e.target.files);
      files.forEach((file, idx) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const newId = Date.now() + idx;
          setImages(prev => [...prev, { id: newId, src: event.target.result, file }]);
        };
        reader.readAsDataURL(file);
      });
    };
    fileInput.click();
  };

  const removeImage = (id) => {
    setImages(prev => prev.filter(img => img.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await createUnitUpdate({ unit_id: unitId, description, images: images.map(img => img.file) });
      if (res.data && res.data._id) {
        const details = await fetchUnitUpdateDetails(res.data._id);
        onSuccess(details.data);
      } else {
        onSuccess(null);
      }
    } catch (err) {
      setSubmitError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.updatesContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLeft}>
          <button className={styles.cancelButton} onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <h2 className={styles.headerTitle}>Add Unit Update</h2>
        </div>
        <div className={styles.headerActions}>
          <button type="button" className={styles.saveButton} onClick={handleSubmit} disabled={loading}>
            {loading ? 'Adding...' : 'Add Update'}
          </button>
        </div>
      </div>
      <div className={styles.unitUpdateFormContainer}>
        <form className={styles.unitUpdateForm} onSubmit={handleSubmit}>
          <div className={styles.formSection}>
            <div className={styles.formGroup}>
              <label className={styles.unitUpdateLabel} htmlFor="description">Description</label>
              <textarea
                id="description"
                className={styles.editTextarea}
                value={description}
                onChange={e => setDescription(e.target.value)}
                rows={6}
                disabled={loading}
                placeholder="Enter update description..."
              />
              {errors.description && <div className={styles.formError}>{errors.description}</div>}
            </div>
          </div>
          <div className={styles.formSection}>
            <div className={styles.formGroup}>
              <label className={styles.unitUpdateLabel}>Images</label>
              {images.length === 0 ? (
                <div className={styles.uploadContainer}>
                  <div className={styles.uploadIcon}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7,10 12,15 17,10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </div>
                  <p className={styles.uploadText}>Upload Images</p>
                  <button type="button" className={styles.uploadButton} onClick={handleImageUpload} disabled={loading}>
                    Choose Files
                  </button>
                </div>
              ) : (
                <>
                  <div className={styles.imageGrid}>
                    {images.map(img => (
                      <div key={img.id} className={styles.imageItem}>
                        <img src={img.src} alt="Preview" />
                        <button type="button" className={styles.removeButton} onClick={() => removeImage(img.id)} disabled={loading}>
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                  <button type="button" className={styles.uploadButton} onClick={handleImageUpload} disabled={loading}>
                    Upload More Images
                  </button>
                </>
              )}
              {errors.images && <div className={styles.formError}>{errors.images}</div>}
            </div>
            {submitError && <div className={styles.formError}>{submitError}</div>}
          </div>
        </form>
      </div>
    </div>
  );
} 